import AuthLayout from '@/layouts/auth/AuthLayout.vue'

export default [
  {
    path: '/login',
    component: AuthLayout,
    children: [
      {
        path: '',
        name: 'login',
        meta: {
          title: 'Login',
        },
        component: () => import('@/views/auth/SignIn.vue'),
      },
    ],
  },
]
